import req from './../../../../../fetch';
import { undocumentedResponse } from './../../../../../utils';
import {
  ClaimsPostResponseType,
  NetworkType,
  AllAPIResponses,
  CarbonError,
} from './../../../../../index';
type Params = {
  networkType: NetworkType;
  id: number;
};

type Payload = {
  data: string;
};

const post = async (
  params: Params,
  body: Payload,
  headers?: Headers
): Promise<AllAPIResponses<ClaimsPostResponseType>> => {
  try {
    const resp = await req.post(
      `/api/claims/${params.networkType}/${params.id}/queue`,
      JSON.stringify(body),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as ClaimsPostResponseType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
